"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference path="../Tone.d.ts" />
if (typeof window === 'undefined') {
    global.window = {};
}
var Tone = require("tone");
var types_1 = require("./types");
var tone_object_1 = require("./tone-object");
var life_cycle_1 = require("./life-cycle");
var audio_bank_1 = require("./audio-bank");
;
;
exports.defaultOptions = {
    timings: life_cycle_1.defaultAudioTimings,
    bufferScheme: 'dynamic'
};
var Schedulo = /** @class */ (function () {
    function Schedulo(timings, fadeLength) {
        if (timings === void 0) { timings = life_cycle_1.defaultAudioTimings; }
        if (fadeLength === void 0) { fadeLength = 0.01; }
        this.timings = timings;
        this.fadeLength = fadeLength;
        this.scheduledObjects = [];
        var bufferWindow = timings.loadBuffer.countIn + timings.loadBuffer.countOut;
        this.audioBank = new audio_bank_1.AudioBank(bufferWindow);
        this.reverb = new Tone.Freeverb().toMaster();
        this.delay = new Tone.FeedbackDelay(0.5, 0.6).toMaster();
        //this.reverb = new Tone.Volume(0);
        //this.delay = new Tone.Volume(0);
        this.start();
    }
    Schedulo.prototype.getAudioBank = function () {
        return this.audioBank;
    };
    Schedulo.prototype.setLoop = function (start, stop) {
        Tone.Transport.loop = true;
        Tone.Transport.loopStart = start;
        Tone.Transport.loopEnd = stop;
    };
    Schedulo.prototype.setTempo = function (bpm) {
        Tone.Transport.bpm.value = bpm;
    };
    Schedulo.prototype.setMeter = function (numerator, denominator) {
        Tone.Transport.timeSignature = [numerator, denominator];
    };
    Schedulo.prototype.start = function () {
        Tone.Transport.start("+0.1");
    };
    /** pauses if not paused, resumes otherwise */
    Schedulo.prototype.pause = function () {
        if (Tone.Transport.state == "started") {
            Tone.Transport.pause("+0.1");
        }
        else if (Tone.Transport.state == "paused") {
            this.start();
        }
    };
    Schedulo.prototype.scheduleAudio = function (fileUris, startTime, mode) {
        var _this = this;
        var times = this.calculateScheduleTime(startTime);
        var objects = fileUris.map(function (f) {
            return new tone_object_1.TonejsAudioObject(f, _this.audioBank, _this.timings, _this.fadeLength, _this.reverb, _this.delay, times);
        });
        this.scheduledObjects = this.scheduledObjects.concat(objects);
        return objects;
    };
    Schedulo.prototype.scheduleEvent = function (triggerFunction, time) {
        var startTime = this.calculateScheduleTime(time);
        return new tone_object_1.TonejsEventObject(triggerFunction, startTime, this.timings);
    };
    Schedulo.prototype.transition = function (from, toAudioFiles, startTime, mode, playbackMode) {
        var time = this.calcAbsoluteSchedTime(startTime);
        var duration = mode instanceof types_1.TransitionWithCrossfade ? mode.duration : 0;
        var obj = this.scheduleAudio(toAudioFiles, startTime, playbackMode);
        //fade in
        obj.forEach(function (o) {
            o.set(types_1.Parameter.Amplitude, -Infinity);
            o.ramp(types_1.Parameter.Amplitude, 0, duration, time);
        });
        //fade out
        from.forEach(function (o) { return o.ramp(types_1.Parameter.Amplitude, -Infinity, duration, time); });
        return obj;
    };
    Schedulo.prototype.stopAudio = function (objects, time, mode) {
        var stopTime = this.calcAbsoluteSchedTime(time);
        var duration = mode instanceof types_1.StopWithFadeOut ? mode.duration : 0;
        objects.forEach(function (o) { return o.ramp(types_1.Parameter.Amplitude, -Infinity, duration, stopTime); });
    };
    Schedulo.prototype.calcAbsoluteSchedTime = function (time) {
        var absTime = this.calculateScheduleTime(time);
        return absTime.ref + absTime.onset;
    };
    //pair of ref and time
    Schedulo.prototype.calculateScheduleTime = function (time) {
        if (time instanceof types_1.ScheduleAfter) {
            // TODO this isn't going to work for objects with an indeterminate duration.
            // This is only really complicated by the fact that we want to be able to
            // loop audio continuiously, i.e. n repeats is not known ahead of time.
            // Looping will eventually stop based on some external event, and so
            // at some unknown point in the future, it eventually ends.
            // Unfortunately, unless it is possible to obtain the explicit eventual
            // stop time prior to it occuring, there is going to be a delay in scheduling
            // the next event. Either way, we can't know any time upfront...
            // so this needs rethinking
            return { ref: new Tone.Time(calculateEndTime(time.objects)).toSeconds() - this.fadeLength };
        }
        else if (time instanceof types_1.ScheduleRelativeTo) {
            //const diff = new Tone.Time(add(time.object.getStartTime(), time.delta)).toSeconds();
            //console.log("CALC", this.timings.connectToGraph.countIn)
            var delta = new Tone.Time(time.delta).toSeconds();
            return { ref: time.object.getScheduleTime(), onset: delta };
        }
        else if (time instanceof types_1.ScheduleAt) {
            //adjust to changing count in!!
            return { ref: new Tone.Time(time.at).toSeconds() };
        }
        else if (time instanceof types_1.ScheduleNext) {
            var subdiv = time.next === types_1.Subdivision.Bar ? "1m" : "1n";
            return { ref: Tone.Transport.nextSubdivision(subdiv) };
        }
        else if (time instanceof types_1.ScheduleIn) {
            return { ref: Tone.Transport.nextSubdivision(time.inn) };
        }
        else { //instanceof Asap!!
            return { ref: Tone.Transport.seconds };
        }
    };
    return Schedulo;
}());
exports.Schedulo = Schedulo;
//TODO GET RID OF THIS, NEEDS TO BE DYNAMIC, WITH DEPENDENCIES
function calculateEndTime(objects) {
    var endTimes = objects.map(function (o) { return o.getScheduleTime() + o.getDuration(); });
    return Math.max.apply(Math, endTimes);
}



//////////////////
// WEBPACK FOOTER
// ./~/schedulo/lib/schedulo.js
// module id = 2051
// module chunks = 3